import React, { Suspense } from "react";
import { Switch, Redirect } from "react-router-dom";
import PrivateRoute from "components/PrivateRoute";
import { strings } from "res";
import Loading from "components/shared-components/Loading";

// Pages
import DASHBOARD from "./dashboard";
import CATEGORIES from "./categories";
import CONTENTS from "./contents";
import DEWAN from "./dewan";
import FRAKSI from "./fraksi";
import KOMISI from "./komisi";
import SIDANG from "./sidang";
import INVITATION from "./undangan";
import KEPEGAWAIAN from "./kepegawain";
import MESSAGES from "./messages";
import PANDUAN from "./panduan";
import USERS from "./users";
import SUBCATEGORY from "./subcategories";
import { DOCUMENT } from "./document";
import { VIDEO } from "./video";
import { IMAGE } from "./image";
import { JDIH } from "./jdih";
import KEGIATANKU from "./kegiatanku";
import { PROGRAM } from "./program";
import { ASPIRASI } from "./aspirasi";
import { ACTIVITY } from "./activity";
import { RESES } from "./reses";

// Detail
import DETAIL_CATEGORY from "./detail-category";
import DETAIL_CONTENT from "./detail-content";
import DETAIL_DEWAN from "./detail-dewan";
import DETAIL_SIDANG from "./detail-sidang";
import DETAIL_UNDANGAN from "./detail-undangan";
import DETAIL_MESSAGE from "./detail-message";
import DETAIL_KEPEGAWAIAN from "./detail-kepegawaian";
import DETAIL_KOMISI from "./detail-komisi";
import DETAIL_FRAKSI from "./detail-fraksi";
import DETAIL_USER from "./detail-user";
import DETAIL_TAG from "./detail-tag";
import DETAIL_SUBCATEGORY from "./detail-subcategory";
import DETAIL_DOCUMENT from "./detail-document";
import DETAIL_JDIH from "./detail-jdih";
import DETAIL_IMAGE from "./detail-image";
import DETAIL_VIDEO from "./detail-video";
import DETAIL_PROGRAM from "./detail-program";
import DETAIL_ASPIRASI from "./detail-aspirasi";
import DETAIL_ACTIVITY from "./detail-activity";
import DETAIL_RESES from "./detail-reses";

// Detail2
import DETAIL_UNDANGAN2 from "./undangan/DetailUndangan";

import SETTINGS from "./settings";
import { TAGS } from "./tags";
import { STATIC } from "./static";
import DETAIL_STATIC from "./static-detail";

export const AppViews = ({ match }) => {
  return (
    <Suspense fallback={<Loading cover="content" />}>
      <Switch>
        <PrivateRoute
          path={`${strings.navigation.path.dashboard}`}
          component={DASHBOARD}
        />
        <PrivateRoute
          path={`${strings.navigation.path.kegiatan_dewan}`}
          component={KEGIATANKU}
        />
        <PrivateRoute
          path={`${strings.navigation.path.categories}`}
          component={CATEGORIES}
        />
        <PrivateRoute
          path={`${strings.navigation.path.kepegawaian}`}
          component={KEPEGAWAIAN}
        />
        <PrivateRoute
          path={`${strings.navigation.path.subcategories}`}
          component={SUBCATEGORY}
        />
        <PrivateRoute
          path={`${strings.navigation.path.sidang}`}
          component={SIDANG}
        />
        <PrivateRoute
          path={`${strings.navigation.path.undangan}`}
          component={INVITATION}
        />
        <PrivateRoute
          path={`${strings.navigation.path.contents}`}
          component={CONTENTS}
        />
        <PrivateRoute
          path={`${strings.navigation.path.komisi}`}
          component={KOMISI}
        />
        <PrivateRoute
          path={`${strings.navigation.path.fraksi}`}
          component={FRAKSI}
        />
        <PrivateRoute
          path={`${strings.navigation.path.dewan}`}
          component={DEWAN}
        />
        <PrivateRoute
          path={`${strings.navigation.path.messages}`}
          component={MESSAGES}
        />
        <PrivateRoute
          path={`${strings.navigation.path.users}`}
          component={USERS}
        />
        <PrivateRoute
          path={`${strings.navigation.path.tags}`}
          component={TAGS}
        />
        <PrivateRoute
          path={`${strings.navigation.path.document}`}
          component={DOCUMENT}
        />
        <PrivateRoute
          path={`${strings.navigation.path.image}`}
          component={IMAGE}
        />
        <PrivateRoute
          path={`${strings.navigation.path.video}`}
          component={VIDEO}
        />
        <PrivateRoute
          path={`${strings.navigation.path.jdih}`}
          component={JDIH}
        />
        <PrivateRoute
          path={`${strings.navigation.path.program}`}
          component={PROGRAM}
        />
        <PrivateRoute
          path={`${strings.navigation.path.aspirasi}`}
          component={ASPIRASI}
        />
        <PrivateRoute
          path={`${strings.navigation.path.activity}`}
          component={ACTIVITY}
        />
        <PrivateRoute
          path={`${strings.navigation.path.reses}`}
          component={RESES}
        />

        {/* DETAIL */}
        <PrivateRoute
          path={`${strings.navigation.path.detail_content}`}
          component={DETAIL_CONTENT}
        />
        <PrivateRoute
          path={`${strings.navigation.path.detail_fraksi}`}
          component={DETAIL_FRAKSI}
        />
        <PrivateRoute
          path={`${strings.navigation.path.detail_komisi}`}
          component={DETAIL_KOMISI}
        />
        <PrivateRoute
          path={`${strings.navigation.path.detail_dewan}`}
          component={DETAIL_DEWAN}
        />
        <PrivateRoute
          path={`${strings.navigation.path.detail_kepegawaian}`}
          component={DETAIL_KEPEGAWAIAN}
        />
        <PrivateRoute
          path={`${strings.navigation.path.detail_sidang}`}
          component={DETAIL_SIDANG}
        />
        <PrivateRoute
          path={`${strings.navigation.path.detail_undangan}`}
          component={DETAIL_UNDANGAN}
        />
        <PrivateRoute
          path={`${strings.navigation.path.detail_category}`}
          component={DETAIL_CATEGORY}
        />
        <PrivateRoute
          path={`${strings.navigation.path.detail_message}`}
          component={DETAIL_MESSAGE}
        />
        <PrivateRoute
          path={`${strings.navigation.path.detail_user}`}
          component={DETAIL_USER}
        />
        <PrivateRoute
          path={`${strings.navigation.path.detail_tag}`}
          component={DETAIL_TAG}
        />
        <PrivateRoute
          path={`${strings.navigation.path.detail_subcategory}`}
          component={DETAIL_SUBCATEGORY}
        />
        <PrivateRoute
          path={`${strings.navigation.path.detail_document}`}
          component={DETAIL_DOCUMENT}
        />

        <PrivateRoute
          path={`${strings.navigation.path.detail_jdih}`}
          component={DETAIL_JDIH}
        />

        <PrivateRoute
          path={`${strings.navigation.path.detail_image}`}
          component={DETAIL_IMAGE}
        />

        <PrivateRoute
          path={`${strings.navigation.path.detail_video}`}
          component={DETAIL_VIDEO}
        />

        <PrivateRoute
          path={`${strings.navigation.path.detail_program}`}
          component={DETAIL_PROGRAM}
        />

        <PrivateRoute
          path={`${strings.navigation.path.detail_aspirasi}`}
          component={DETAIL_ASPIRASI}
        />

        <PrivateRoute
          path={`${strings.navigation.path.detail_activity}`}
          component={DETAIL_ACTIVITY}
        />

        <PrivateRoute
          path={`${strings.navigation.path.detail_reses}`}
          component={DETAIL_RESES}
        />

        <PrivateRoute
          path={`${strings.navigation.path.settings}`}
          component={SETTINGS}
        />

         <PrivateRoute
          path={`${strings.navigation.path.panduan}`}
          component={PANDUAN}
        />

        {/* DETAIL2 */}
        <PrivateRoute
          path={`${strings.navigation.path.detail_undangan2}`}
          component={DETAIL_UNDANGAN2}
        />

        {/* STATIC */}
        <PrivateRoute
          path={`${strings.navigation.path.static_list}`}
          component={STATIC}
        />

        <PrivateRoute
          path={`${strings.navigation.path.static_detail}`}
          component={DETAIL_STATIC}
        />

        <Redirect
          from={`${match.url}`}
          to={`${strings.navigation.path.dashboard}`}
        />
      </Switch>
    </Suspense>
  );
};

export default AppViews;
